// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: true,
	organizationPrefix: 'TNP',
	organizationUUID: 'b7e313ce-7236-4b77-ba76-a98366e22044',
	accountId: 'tecnopool',
  appIdIos: 'it.addiction.catalean.tecnopool',
	appIdAndroid: 'it.addiction.catalean.tecnopool',
	authenticationUrl: 'https://auth.datalean-nodejs.catalean.com/',
	configUrl: 'https://configuration.datalean-nodejs.catalean.com/',
	// authenticationUrl: 'http://localhost:3020/',
	medialibraryUrl: 'https://media-library.datalean-nodejs.catalean.com/media-library/v2/',
	cataleanCacheUrl: 'https://cache.catalean.com/v1/',
	productsUrl: 'https://core-entities.datalean-nodejs.catalean.com/product/v2/',
	wishlistUrl: 'https://core-entities.datalean-nodejs.catalean.com/wishlist/',
	usersUrl: 'https://user.datalean-nodejs.catalean.com/user/application/',
	userStructureUrl: 'https://structure.datalean-nodejs.catalean.com/applicationUserStructure/',
	structuresUrl: 'https://structure.datalean-nodejs.catalean.com/structure/v2/',
	organizationUrl: 'https://organization.datalean-nodejs.catalean.com/organization/',
	shareLinkUrl: 'https://translator.datalean-nodejs.catalean.com/share/',
	shareLinkParseUrl: 'https://translator.datalean-nodejs.catalean.com/share/parse',
	templateUrl: 'https://translator.datalean-nodejs.catalean.com/template/',
	applicationGroupUrl: 'https://user.datalean-nodejs.catalean.com/user/application/groups/',
	defaultLocale: 'en-US',
	version: '1.0.0',
	availableLocales: ['en-US', 'es-ES', 'fr-FR'],
	uuidParameterType: 'MAP_CONTAINER_UUID',
	// 1: normal logout, 2: overwrite check assets to delete on next login, 3: delete assets on logout
	logoutDataRetentionMode: 1,
	resourceBatchLimit: 1,
	catalean: {
		version: 1,
		uuid: '2a2b5733-8658-4127-89ae-07b05a611743',
	},
  checkDevice: false,
  // Analytics configuration
  analytics: {
    enabled: false,
    debug: false, // Disabled in production
    gtmId: 'GTM-NLKPMFRL',
    iubendaSiteId: 46825190,
  },

  defaultLinesFeature: ['def07368-15be-41f5-b72f-86c6a132b4ef'],
  defaultMachinesFeature: ['1e684378-9b92-417e-9a87-6efa493e1675'],
  defaultIndustrySolutionFeature: 'e8048773-5578-44f4-b13d-52030db7c29e'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
